import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { KeycloakService } from './keycloak.service';
import { AppRole } from './roles';

export function rolesGuard(allowedRoles: AppRole[]): CanActivateFn {
  return () => {
    const authService = inject(KeycloakService);
    const router = inject(Router);

    if (authService.isAdmin() || authService.hasAnyRole(allowedRoles)) {
      return true;
    }

    return router.createUrlTree(['/unauthorized']);
  };
}
